import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.24_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@playwright+test@1.58.2_@types_44f2ee469e58ebe5dd8142f76b11dd6e/node_modules/next/dist/client/app-dir/link.js");
